import React, { Component } from "react";
import { Card, CardContent, CardHeader } from "../../ui/card";
import { Button } from "../../ui/button";
import { Pencil, Trash2, ArrowUpDown, Plus } from 'lucide-react';
import AddEditTrainingVideo from "./AddEditVideo";
import VideoCard from "./VideoCard";
import VideoModal from "./VideoModal";

class TrainingModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideoPopup: false,
            showVideoPlayPopup: false,
            videoId: '',
            videoName: '',
            videoEditMode: false,
            videoEditData: ''
        }
    }
    
    componentDidMount() {
        this.setVideoId = this.setVideoId.bind(this)
    }
    
    showAddVideoPopup() {
        this.setState({ showVideoPopup: true })
    }
    
    hideAddVideoPopup() {
        this.setState({ showVideoPopup: false, videoEditMode: false, videoEditData: '' })
    }
    
    showPlayVideoPopup() {
        this.setState({ showVideoPlayPopup: true })
    }
    
    hidePlayVideoPopup() {
        this.setState({ showVideoPlayPopup: false })
    }
    
    setVideoId = (id, title) => {
        this.setState({ videoId: id, videoName: title })
    }
    
    deleteModule(moduleId) {
        this.props.deleteModule(moduleId)
    }
    
    editModule() {
        if(this.props.editModule) this.props.editModule(true, this.props.moduleData)
    }
    
    editVideo(isEditing, videoData) {
        this.setState({ videoEditMode: isEditing, videoEditData: videoData, showVideoPopup: true })
    }
    
    orderModule = () => {
        try {
            if (this.props.orderVideoList) this.props.orderVideoList(this.props.moduleData)
        } catch (error) { }
    }

    render() {
        return (
            <>
                {this.props.moduleData ? (
                    <Card className="border-gray-200 bg-white">
                        <CardHeader className="border-b border-gray-100 px-6 py-3">
                            <div className="flex items-center justify-between">
                                <h3 className="text-lg font-semibold text-brand-dark">
                                    {this.props.moduleData.moduleName}
                                </h3>
                                <div className="flex items-center gap-2">
                                    {this.props.moduleData.media.length > 1 && (
                                        <Button 
                                            variant="outline" 
                                            size="sm"
                                            className="text-brand-dark border-gray-200 hover:bg-brand-light-1"
                                            onClick={this.orderModule}
                                        >
                                            <ArrowUpDown className="h-4 w-4 mr-2" />
                                            Reorder
                                        </Button>
                                    )}
                                    <Button 
                                        variant="ghost" 
                                        size="icon"
                                        className="text-brand-dark hover:bg-brand-light-1"
                                        onClick={this.editModule.bind(this)}
                                    >
                                        <Pencil className="h-4 w-4" />
                                    </Button>
                                    <Button 
                                        variant="ghost" 
                                        size="icon"
                                        className="text-red-500 hover:bg-red-50"
                                        onClick={() => this.deleteModule(this.props.moduleData.objectUID)}
                                    >
                                        <Trash2 className="h-4 w-4" />
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                        <CardContent className="pt-6">
                            {this.props.moduleData.media.length > 0 ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 xl:grid-cols-3 gap-4">
                                    {this.props.moduleData.media.map((item, index) => (
                                        <VideoCard 
                                            key={index} 
                                            videoData={item}
                                            getVideoId={this.setVideoId}
                                            showVideoModal={this.showPlayVideoPopup.bind(this)}
                                            editVideo={() => this.editVideo(true, item)}
                                            moduleId={this.props.moduleData.objectUID}
                                            videoDeleted={this.props.videoDeleted}
                                        />
                                    ))}
                                    <Button
                                        variant="outline"
                                        className="h-full min-h-[200px] border-[3px] border-dashed border-gray-400 bg-brand-light-1 hover:bg-brand-light-1 hover:border-brand-accent transition-all"
                                        onClick={this.showAddVideoPopup.bind(this)}
                                    >
                                        <div className="flex flex-col items-center gap-2">
                                            <Plus className="h-10 w-10 text-brand-accent" />
                                            <span className="text-brand-dark font-medium text-md">Add More Media</span>
                                        </div>
                                    </Button>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-8">
                                    <p className="text-gray-500 mb-4">No media added yet</p>
                                    <Button
                                        onClick={this.showAddVideoPopup.bind(this)}
                                        variant="secondary"
                                    >
                                        <Plus className="h-4 w-4 mr-2" />
                                        Add Media
                                    </Button>
                                </div>
                            )}
                        </CardContent>
                    </Card>
                ) : null}
                
                {this.state.showVideoPopup && (
                    <AddEditTrainingVideo 
                        moduleData={this.props.moduleData} 
                        hideModal={this.hideAddVideoPopup.bind(this)} 
                        mode={this.state.videoEditMode ? "EDIT" : 'ADD'} 
                        videoData={this.state.videoEditData} 
                        changeInVideo={this.props.changeInVideo} 
                    />
                )}
                
                {this.state.showVideoPlayPopup && (
                    <VideoModal 
                        hideModal={this.hidePlayVideoPopup.bind(this)} 
                        videoId={this.state.videoId} 
                        videoName={this.state.videoName} 
                    />
                )}
            </>
        )
    }
}

export default TrainingModule;
